/** Public (unauthenticated) routes. */
export default [

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/public/LoginView.vue'),
    meta: {
      public: true,
      title: 'Login',
    },
  },

];
